import { render, staticRenderFns } from "./ArmsRegArchiveDestructionInfo.vue?vue&type=template&id=7227d2ac&scoped=true&"
import script from "./ArmsRegArchiveDestructionInfo.vue?vue&type=script&lang=js&"
export * from "./ArmsRegArchiveDestructionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7227d2ac",
  null
  
)

export default component.exports